import React from "react";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";

const merchItems = [
  {
    name: "Alice Street Logo Cap",
    description: "Black washed cap with embroidered Alice Street logo.",
    price: "£25",
    link: "#",
  image: "/shop-cap-logo.png"
  },
  {
    name: "Sun Embroidered Cap",
    description: "Black washed cap with yellow sun embroidery.",
    price: "£25",
    link: "#",
  image: "/shop-cap-sun.png"
  },
  {
    name: "Oh What A Day! Sweatshirt",
    description: "White sweatshirt with 'Oh What A Day! What A Lovely Day!' print.",
    price: "£35",
    link: "#",
  image: "/shop-sweatshirt.png"
  },
  {
    name: "Oh What A Day! T-Shirt",
    description: "White t-shirt with 'Oh What A Day! What A Lovely Day!' print.",
    price: "£20",
    link: "#",
  image: "/shop-tshirt.png"
  }
];

const Merch = () => (
  <Container className="py-5" id="shop">
    <h2 className="display-4 mb-5 text-center">Shop</h2>
    <Row>
      {merchItems.map((item, idx) => (
        <Card key={idx} className="m-3 shadow" style={{ width: "22rem" }}>
          <Card.Img variant="top" src={item.image} alt={item.name} />
          <Card.Body>
            <Card.Title>{item.name}</Card.Title>
            <Card.Text>{item.description}</Card.Text>
            <Card.Text><strong>{item.price}</strong></Card.Text>
            <Card.Link href={item.link} target="_blank" rel="noopener noreferrer">
              Buy Now
            </Card.Link>
          </Card.Body>
        </Card>
      ))}
    </Row>
  </Container>
);

export default Merch;
